export default __webpack_public_path__ + "static/media/Mail_Icon.3eaa02d7.svg";